import styled from "styled-components";
import { designTokens, getTypography } from "styles/designTokens";

export const AccountPageContainer = styled.div<{ $isCollapsed?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${designTokens.colors.font.primary};
  max-width: 720px;
  width: 100%;
  margin: 0 auto;
  padding: 80px 20px;
  gap: 24px;
  transition: margin-left 0.3s ease;
`;

export const SectionTitle = styled.h3`
  ${getTypography("korean", "title1")};
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 12px 0;
  color: #1a1a1a;
  display: flex;
  align-items: center;
`;

export const SectionDescription = styled.p`
  ${getTypography("korean", "body3")};
  color: #6c6f82;
  font-size: 14px;
  margin: 0 0 28px 0;
  align-self: flex-start;
`;

export const FormCard = styled.section`
  width: 100%;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #eef0f5;
  box-shadow: 0 4px 16px rgba(10, 16, 30, 0.05);
  padding: 36px;
  transition: box-shadow 0.25s ease;

  &:hover {
    box-shadow: 0 6px 24px rgba(10, 16, 30, 0.08);
  }

  @media (max-width: 768px) {
    padding: 24px;
  }
`;

export const FormSection = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FieldRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: 640px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

export const FieldLabel = styled.label`
  ${getTypography("korean", "body3")};
  font-weight: 500;
  color: #333;
  min-width: 120px;
  text-align: left;

  @media (max-width: 640px) {
    text-align: left;
  }
`;

export const FieldInputWrapper = styled.div`
  flex: 1;
  width: 100%;

  input {
    width: 100%;
    height: 44px;
    border-radius: 4px;
    border: 1px solid #e9ecf3;
    background: #fafafb;
    padding: 10px 14px;
    ${getTypography("korean", "body3")};

    &::placeholder {
      color: ${designTokens.colors.font.tertiary};
    }

    &:hover {
      border-color: #d6dbff;
      background: #fff;
    }

    &:focus {
      outline: none;
      border-color: #5c6eff;
      background: #fff;
      box-shadow: 0 0 0 3px rgba(92, 110, 255, 0.12);
    }

    &:disabled {
      background: #f6f7fb;
      color: #9aa0ad;
      cursor: not-allowed;
    }
  }
`;

export const FormButton = styled.button`
  width: 100%;
  height: 46px;
  border: none;
  border-radius: 8px;
  background: #5c6eff;
  color: #fff;
  font-weight: 600;
  font-size: 15px;
  transition: background 0.25s ease, transform 0.2s ease;

  &:hover {
    background: #4b5eff;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background: #dfe2ff;
    cursor: not-allowed;
  }
`;

interface PasswordHintProps {
  error?: boolean;
}

export const PasswordHint = styled.span<PasswordHintProps>`
  display: inline-block;
  margin-top: 6px;
  color: ${({ error }) => (error ? "#DC3545" : designTokens.colors.font.quaternary)};
  ${getTypography("korean", "body4")};
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 24px;
  justify-content: flex-end;
`;

export const SmallButton = styled.button<{ $danger?: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  border: none;
  border-radius: 6px;
  padding: 8px 14px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  background: ${({ $danger }) => ($danger ? "#ff4d4f" : "#5c6eff")};
  color: white;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ $danger }) => ($danger ? "#e04344" : "#4b5eff")};
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;
